module.exports = __webpack_public_path__ + "img/1084.2c62995a.svg";